import { render, staticRenderFns } from "./virtualsimulationexperiments.vue?vue&type=template&id=496b372a&scoped=true&"
import script from "./virtualsimulationexperiments.vue?vue&type=script&lang=js&"
export * from "./virtualsimulationexperiments.vue?vue&type=script&lang=js&"
import style0 from "./virtualsimulationexperiments.vue?vue&type=style&index=0&id=496b372a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496b372a",
  null
  
)

export default component.exports